import { AbstractControl, FormGroup } from '@angular/forms';

export abstract class AbstractEntityEditComponent {
  // hasFormError = false;
  // saving = false;
  //
  // labels: { key: string; value: string }[] = [];
  //
  // getLabel(key: string) {
  //   return this.labels.find((l) => l.key === key)?.value || key;
  // }

  static bindErrorsToForm(responseErrors: any, form: FormGroup) {
    if (!responseErrors || !responseErrors.errors) {
      return;
    }
    for (const field of Object.keys(responseErrors.errors)) {
      AbstractEntityEditComponent.bindErrorsToControl(responseErrors.errors[field], form.controls[field]);
    }
  }

  static bindErrorsToControl(responseErrors: any, control: AbstractControl | null) {
    if (control) {
      let errors = control.errors || {};
      for (const error of responseErrors) {
        errors[error] = error;
      }
      control.setErrors(errors);
      control.markAsDirty();
    }
  }

  getFormValidationErrors(form: FormGroup): string[] {
    const errors: string[] = [];
    Object.keys(form.controls).forEach((key) => {
      const controlErrors = form.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          errors.push(`${key} has error: ${errorKey}`);
        });
      }
    });
    return errors;
  }

  // static formatErrorsMessage(responseErrors: any): string {
  //   let str = '';
  //   for (const field of Object.keys(responseErrors)) {
  //     for (const error of responseErrors[field]) {
  //       str += field + ': ' + error.message;
  //     }
  //   }
  //   return str;
  // }
}
